import React, {Component} from "react"

export default class SearchField extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value)
    }
  }

  handleSubmit(event) {
    if (this.props.onSubmit && event.key === "Enter") {
      this.props.onSubmit()
    }
  }

  render() {
    return (
      <div className="sh-search-field">
        <input
          type="text"
          onChange={this.handleChange}
          onKeyPress={this.handleSubmit.bind(this)}
          placeholder={this.props.placeholder}
          value={this.props.value}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/SearchField.js